import { atom, useSetRecoilState } from 'recoil';

export const livePreviewVisibleState = atom({
  key: 'healthcareProgram_livePreviewVisible',
  default: true
});

export const useToggleLivePreview = () => {
  const setVisible = useSetRecoilState(livePreviewVisibleState);
  return () => setVisible((v) => !v);
};
